export default "__VITE_ASSET__Dw4p20FG__"